"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.importUnits = exports.update = exports.create = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const unitsService_1 = require("./service/unitsService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('units/fetch', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const unitsService = new unitsService_1.UnitsService(Env_1.APIPATHENV);
        const response = yield unitsService.fetchUnits(payload);
        return response;
    }
    catch (err) {
        throw new Error("Failed to fetch units");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('units/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const unitsService = new unitsService_1.UnitsService(Env_1.APIPATHENV);
        const response = yield unitsService.createUnits(payload);
        return response;
    }
    catch (err) {
        throw new Error(err);
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('units/update', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const unitsService = new unitsService_1.UnitsService(Env_1.APIPATHENV);
        const response = yield unitsService.updateUnits(payload);
        return response;
    }
    catch (err) {
        throw new Error(err);
    }
}));
exports.importUnits = (0, toolkit_1.createAsyncThunk)('units/import', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const unitsService = new unitsService_1.UnitsService(Env_1.APIPATHENV);
        const response = yield unitsService.importUnits(payload);
        return response;
    }
    catch (err) {
        throw new Error(err);
    }
}));
